export function formatResourceConditionNode(conditionNode) {
  return getResourceConditionRows(conditionNode)
    .map((condition) => [condition.conditionType, condition.operator, condition.value].filter(Boolean).join(" | "))
    .join(` ${conditionNode?.conjunction || "AND"} `);
}

export function getResourceConditionRows(conditionNode) {
  if (!conditionNode) {
    return [];
  }

  return (conditionNode.terms || []).flatMap((term) => formatConditionTerm(term));
}

function formatConditionTerm(term) {
  if (!term) {
    return [];
  }

  const row = {
    conditionType: formatConditionType(term.variableName),
    operator: formatOperator(term.operator),
    value: formatConditionValue(term.operands),
  };
  const nestedRows = getResourceConditionRows(term);

  return [row, ...nestedRows].filter((condition) =>
    condition.conditionType || condition.operator || condition.value
  );
}

function formatConditionType(variableName) {
  switch (variableName) {
    case "Conversation.agents":
      return "User";
    default:
      return formatLabel(variableName);
  }
}

function formatOperator(operator) {
  switch (operator) {
    case "EQ":
      return "Equals";
    default:
      return formatLabel(operator);
  }
}

function formatConditionValue(operands = []) {
  return operands
    .map((operand) => {
      switch (operand.value) {
        case "User.id":
          return "Current User";
        default:
          return formatLabel(operand.value);
      }
    })
    .filter(Boolean)
    .join(", ");
}

function formatLabel(value) {
  if (!value) {
    return "";
  }

  return value
    .split(".")
    .pop()
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ");
}